import moment from "moment-jalaali";

moment.loadPersian({ usePersianDigits: true });

export function convertToJalaliDateTime(dt, displayTime = true) {
    if (!displayTime) {
        return moment(dt).locale("fa").format("jYYYY/jMM/jDD");
    }
    return moment(dt).locale("fa").format("jYYYY/jMM/jDD HH:mm");
}

export function isToday(date) {
    if (typeof date !== "object") return false;

    const today = new Date();

    if (today.toDateString() === date.toDateString()) {
        return true;
    }

    return false;
}

export function toJalaaliDateTime(
    datetime,
    { displayTime = false, parseZone = false, locale = "fa" } = {}
) {
    let dt = moment(datetime).locale(locale);

    if (parseZone) {
        dt = dt.parseZone();
    }

    if (displayTime) {
        dt = dt.format("jYYYY/jMM/jDD HH:mm:ss");
    } else {
        dt = dt.format("jYYYY/jMM/jDD");
    }

    return dt;
}

export function getCurrentYear() {
    return moment().jYear();
}

export function getAge(birthYear) {
    if (!birthYear) return null;

    return Number(getCurrentYear()) - Number(birthYear);
}
